// extracted by mini-css-extract-plugin
export var easonCaps = "EasonProDisplayCaps, EasonPro, \"Times New Roman\", serif";
export var headerIcon = "index-module--headerIcon--nk7nz";
export var headerLabel = "index-module--headerLabel--piKa6";
export var headerText = "index-module--headerText--tO8vo";
export var mobilePadding = "4vw";
export var mqMaxMd = "screen and (max-width: 48em)";
export var mqMinLg = "screen and (min-width: 67.625em)";
export var mqMinMd = "screen and (min-width: 48em)";
export var mqMinSm = "screen and (min-width: 32em)";
export var red1 = "rgb(245, 13, 27)";
export var sectionHeader = "index-module--sectionHeader--ccJxT index-module--fullWidth--jvj2O util-module--fullWidth--iiqEb";